import { appAlert } from "lib/withOver";
import Dispatcher from "Dispatcher";
import NavigationActions from "data/NavigationActions";

export const alertAndRefocusBuilder = controlProps => {
    const {
        entityForm,
        activeRecord,
        descriptor,
    } = controlProps;
    return msg => appAlert(msg, () => {
        if (entityForm) {
            Dispatcher.contextDispatch(entityForm.fluxContext, {
                type: NavigationActions.FOCUS_FIELD,
                entityKey: activeRecord.entityKey,
                recordId: activeRecord.id,
                fieldKey: descriptor.key,
            });
            return;
        }
        if (!descriptor) return;
        if (!descriptor.id) return;
        const el = document.querySelector(`#${descriptor.id} .focusable, #${descriptor.id} input, #${descriptor.id} select`);
        if (!el) return;
        // I allow the "close the alert" event (which we don't have access to
        // here) to finish itself before focus is placed. If it's a mouse click
        // then that click event will end up focusing the button at the very
        // end, making this focus request irrelevant.
        //
        // eslint-disable-next-line no-settimeout
        setTimeout(() => {
            if (!document.body.contains(el)) return;
            try {
                el.focus();
            } catch (e) {
                console.warn("failed to focus #" + descriptor.id, el, e);
            }
        });
    });
};

export default alertAndRefocusBuilder;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/utils/alertAndRefocusBuilder.js